import { environmentHttpClient } from "client/Api/httpClient";

export type SharePointTeamSiteListItemViewModel = {
	id: string;
	url: string;
	name: string;
};

export function listSites(
	signal?: AbortSignal
): Promise<readonly SharePointTeamSiteListItemViewModel[]> {
	return environmentHttpClient.get<readonly SharePointTeamSiteListItemViewModel[]>(
		"/Workspace/LiveInformation/SharePoint",
		undefined,
		{ signal }
	);
}
